import { useUser } from '@clerk/clerk-react'
import { useMemo } from 'react'
import { z } from 'zod'

import { clinicIdSchema } from '@snootsvet/shared'

const userMetadataSchema = z.object({
  defaultClinicId: clinicIdSchema.nullable().catch(null),
})

export type UserMetadata = z.infer<typeof userMetadataSchema>

/**
 * Reads raw user metadata from Clerk's `unsafeMetadata`,
 * validated with fallback defaults for each setting.
 * Returns `undefined` while Clerk is still loading.
 */
export function useUserMetadata() {
  const { user, isLoaded } = useUser()

  const settings = useMemo<UserMetadata | undefined>(
    () => (isLoaded ? userMetadataSchema.parse(user?.unsafeMetadata ?? {}) : undefined),
    [isLoaded, user?.unsafeMetadata]
  )

  return { settings }
}
